import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__Label_module_js_6892f1e0__ from "./Label.module.js";
function Label({ name, children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("label", {
        className: __WEBPACK_EXTERNAL_MODULE__Label_module_js_6892f1e0__["default"].label,
        htmlFor: name,
        children: children
    });
}
const Label_rslib_entry_ = Label;
export { Label_rslib_entry_ as default };

//# sourceMappingURL=Label.js.map